import type { TISAUser } from '@/types/tisa-coins';
import { getBadgeProgress, getRecentBadges } from '@/lib/tisa-helpers';
import { getBadgeById } from '@/config/tisa-settings';

interface Props {
  user: TISAUser;
}

export function BadgesSection({ user }: Props) {
  const recentBadges = getRecentBadges(user.badge_events, 3);
  const badgeProgress = getBadgeProgress(user.badge_events);
  const totalBadges = Object.keys(badgeProgress).length;

  return (
    <div className="bg-gray-900/50 border-2 border-purple/30 rounded-xl p-6">
      <h2 className="text-xl font-cinzel font-bold text-purple mb-4">
        🏆 Badges ({totalBadges})
      </h2>
      {recentBadges.length === 0 ? (
        <p className="text-gray-400 text-sm text-center py-4">No badges earned yet!</p>
      ) : (
        <div className="space-y-3">
          {recentBadges.map((event, i) => {
            const badge = getBadgeById(event.badge_id);
            if (!badge) return null;
            return (
              <div key={i} className="bg-black/30 border border-purple/20 rounded-lg p-3">
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{badge.icon}</span>
                  <div className="flex-1">
                    <p className="font-poppins font-bold text-white text-sm">{badge.name}</p>
                    <p className="text-xs text-gray-400">{event.tier} - {event.xp_awarded} XP</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <button className="w-full mt-4 px-4 py-2 bg-purple/20 text-purple border border-purple/50 rounded-lg font-bold hover:bg-purple/30">
        View All Badges
      </button>
    </div>
  );
}
